import React from "react";
import { DateInputComponent } from "api-sdk-react";
import { createEmptyNodeInput, DateInputUtils } from "api-sdk";
import { ChatReaderComponentProps } from "../types";

export function DateInput(props: ChatReaderComponentProps<"DATE">) {

    return (
        <DateInputComponent
            inputField={ props.inputField }
            allowNativeDatePicker={ props.config.useNativeDatePicker }
            defaultValue={ props.value?.date }
            onDateChange={ (date: string) => props.onChange(date ? DateInputUtils.asNodeInput(date) : createEmptyNodeInput()) }
            minDateErrorText={ props.config.messages.inputMinDate }
            maxDateErrorText={ props.config.messages.inputMaxDate }
            invalidDateFormatErrorText={ props.config.messages.inputDateInvalid }
            menuControls={ props.menu }
            autoFocus={ props.autoFocus }
        />
    )

}